var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listWrap"},[(_vm.userType==1)?_c('listBrand'):_vm._e(),(_vm.userType==2)?_c('listFactory'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }